import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Role } from 'src/model/role.model';
import { User } from 'src/model/user.model';

interface GetUsersOptions {
  companyId?: number,
  roleId?: number[],
  isActive?: boolean
}

export interface RegisterUserInfo {
  username: string,
  password: string,
  roleId: number,
  companyId?: number,
  salary?: number,
  initialAccountBalance?: number,
  initialAccountDate?: Date
}

@Injectable({
  providedIn: 'root'
})
export class UserAdapter {

  adapt(item: any): User {
    return new User(
      item.id,
      item.companyId,
      item.companyCode,
      item.roleId,
      item.roleName,
      item.username,
      item.password,
      item.salary,
      item.active
    );
  }

  adaptRole(item: any): Role {
    return new Role(
      item.id,
      item.name
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private adapter = inject(UserAdapter);
  private sharedService = inject(SharedService);

  getAllUsers(o?: GetUsersOptions): Promise<User[]> {
    return new Promise<User[]>((resolve, reject) => {
      this.api.get<User[]>(this.constructApi.getAllUsers(o?.companyId, o?.roleId, o?.isActive)).pipe(
        map(data => data.map(d => this.adapter.adapt(d)))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to get all users: ', err);
          reject(err);
        }
      })
    })
  }

  putDeactivateUser(username: string) {
    return new Promise((resolve, reject) => {
      this.api.put(this.constructApi.getDeactivateUser(username)).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to deactivate user: ', err);
          reject(err);
        }
      })
    })
  }

  postRegisterUser(data: RegisterUserInfo) {
    if (data.initialAccountDate !== undefined)
      data.initialAccountDate = this.sharedService.getLastMsOfDate(data.initialAccountDate);
    return new Promise((resolve, reject) => {
      this.api.post(this.constructApi.getSignUp(), data).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to register user: ', err);
          reject(err);
        }
      })
    })
  }

  // #region Role
  getAllRoles(): Promise<Role[]> {
    return new Promise<Role[]>((resolve, reject) => {
      this.api.get<Role[]>(this.constructApi.getAllRoles()).pipe(
        map(data => data.map(d => this.adapter.adaptRole(d)))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to get all roles: ', err);
          reject(err);
        }
      })
    })
  }
  // #endregion
}
